import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useMutation } from '@apollo/client';
import { DateTime } from 'luxon';

import Modal from 'app/src/elements/Modal';
import { Text } from 'app/src/styles';
import { dateShort } from 'app/src/utils/timeFormatter';

import CopyDirectLink from './CopyDirectLink';
import { DESTROY_TXN, UNVOID_TXN } from './queries';
import VoidTxn from './Void';

const TxnActions = ({ txn, refetch }) => {
  const [showVoidModal, setShowVoidModal] = useState(false);

  const [destroyTxn] = useMutation(DESTROY_TXN, {
    onCompleted: () => window.location.href = '/accounting/transactions'
  });

  const [unvoidTxn] = useMutation(UNVOID_TXN, {
    onCompleted: () => {
      if (refetch) { refetch(); }
      if (setShowModal) { setShowModal(false); }
    }
  });

  const handleDelete = () => {
    if (window.confirm('Really delete transaction?')) {
      destroyTxn({ variables: { id: txn.id } });
    }
  };

  const handleUnvoid = () => {
    if (window.confirm('Really reverse void?')) {
      unvoidTxn({ variables: { id: txn.voidBy.id } });
    }
  };

  return (
    <View style={{ flexDirection: 'row', gap: 20, marginBottom: 10 }}>
      <CopyDirectLink txn={txn} />

      {txn.voidBy ? (
        <Pressable onPress={handleUnvoid}>
          <Text>VOIDED {dateShort(txn.voidBy.bankDate)}- Reverse Void</Text>
        </Pressable>
      ) : (
        <Pressable onPress={() => setShowVoidModal(true)}>
          <Text>Void Transaction</Text>
        </Pressable>
      )}

      {txn.createdAt > DateTime.now().minus({ days: 7 }).toISO() && (
        <Pressable onPress={handleDelete}>
          <Text>Delete Transaction</Text>
        </Pressable>
      )}

      {showVoidModal && (
        <Modal
          showModal
          setShowModal={setShowVoidModal}
          modalType="Void Transaction"
        >
          <VoidTxn
            txn={txn}
            setShowModal={setShowVoidModal}
            refetch={refetch}
          />
        </Modal>
      )}
    </View>
  );
};

export default TxnActions;
